var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition-group',{staticClass:"notifications-container",attrs:{"tag":"div","name":"notifications"}},_vm._l((_vm.notifications),function(item){return _c('div',{key:item.params.id},[_c('Notification',{attrs:{"item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }